import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'

export default function Home() {
  const { oid } = useParams()
  const navigate = useNavigate()
  const [assessmentData, setAssessmentData] = useState([])

  useEffect(() => {
    document.title = '职业生涯测评'

    axios.post('/c/assessment/list/get')
      .then(function (response) {
        if (response.errcode === 0) {
          setAssessmentData(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='home-page'>
      <img className='home-cover' src="/images/cover.png" alt="" />

      <div className='home-assessments'>
        {assessmentData.map((item) => (
          <div className='home-assessment' key={item.id} onClick={() => navigate(`/detail/${oid}/${item.code}`)}>
            <img className='home-assessment-bg' src={item.icon_url} alt="" />
            <div className='home-assessment-name'>{item.name}</div>
            <div className='home-assessment-button'>
              <span>开始测试</span>
              <img src="/images/jiantou.png" alt="" />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
